var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M24.5 34C30.0228 34 34.5 29.5228 34.5 24C34.5 18.4772 30.0228 14 24.5 14C18.9772 14 14.5 18.4772 14.5 24C14.5 25.5114 14.8353 26.9446 15.4356 28.229L14.723 32.6245C14.6135 33.3 15.1995 33.8834 15.8745 33.7709L20.2298 33.045C21.5248 33.6575 22.9724 34 24.5 34Z",
    fill: "url(#paint0_linear_13711_154122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 27.1111V26.3796C28.5 26.0161 28.2787 25.6893 27.9412 25.5543L27.0372 25.1926C26.6079 25.021 26.1188 25.2069 25.912 25.6204L25.8333 25.7778C25.8333 25.7778 24.7222 25.5556 23.8333 24.6667C22.9444 23.7778 22.7222 22.6667 22.7222 22.6667L22.8796 22.588C23.2931 22.3812 23.479 21.8921 23.3074 21.4628L22.9457 20.5588C22.8107 20.2213 22.4839 20 22.1204 20H21.3889C20.898 20 20.5 20.398 20.5 20.8889C20.5 24.8162 23.6838 28 27.6111 28C28.102 28 28.5 27.602 28.5 27.1111Z",
    fill: "url(#paint1_linear_13711_154122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13711_154122",
    x1: 19.4231,
    y1: 32.3548,
    x2: 57.608,
    y2: -9.93848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13711_154122",
    x1: 22.4692,
    y1: 27.3419,
    x2: 37.7432,
    y2: 10.4246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8ea2b92b1294acff2629ef7114bc0fb4.svg";
export { ForwardRef as ReactComponent };